import { render, staticRenderFns } from "./RoomItemize.vue?vue&type=template&id=40f68e2b&scoped=true"
import script from "./RoomItemize.vue?vue&type=script&lang=js"
export * from "./RoomItemize.vue?vue&type=script&lang=js"
import style0 from "./RoomItemize.vue?vue&type=style&index=0&id=40f68e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f68e2b",
  null
  
)

export default component.exports